module.exports = __webpack_public_path__ + "img/logo.1cef5742.png";